"use client"

import { useAuth } from "../../contexts/AuthContext"
import UnauthorizedPage from "../pages/auth/UnauthorizedPage"

export default function RoleGuard({ allowedRoles, children }) {
  const { user } = useAuth()
  const currentRole = (user?.role || "user").toLowerCase()

  if (!allowedRoles.map((r) => r.toLowerCase()).includes(currentRole)) {
    return <UnauthorizedPage />
  }

  return children
}
